<template>
  <div class="contact-container">
    <div class="contact-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="contact-main">
      <topMap/>
      <businessEcharts/>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {getBannerList} from "@/api/apiHome";
import carousel from '@/components/carousel/index.vue'
import topMap from './components/topMap.vue'
import businessEcharts from './components/businessEcharts.vue'

const bannerList = ref([])
const queryBannerList = async () => {
  const {code, data} = await getBannerList(6)
  if (code === 200) {
    bannerList.value = data
  }
}
queryBannerList()
</script>
<style lang="scss" scoped>

.contact-top {
  width: 100%;
  height: 450px;
  overflow: hidden;
}
.contact-main{
  box-sizing: border-box;
}
</style>
